import React from 'react'
import WufooForm from 'react-wufoo-embed'

import Layout from '../components/layout'

const ContactPage = () => (
  <Layout>
     <h2>Telephone</h2>
        <p>Give us a call at <span style={{fontWeight: "bold"}}>(516) 625-9051</span>.</p>
        <h2>Address</h2>
        <code>Lawrence Hoffman, CPA, PC<br />30 Ursula Drive<br />Roslyn, NY 11576-3021</code>
        <h2>Email</h2>
        <p>
            <WufooForm userName="tekmaven" formHash="q11wvsdc0v27rm1" header="hide" />
        </p>
  </Layout>
)

export default ContactPage
